import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box
} from '@mui/material';
import StyledButton from './StyledButton';

const ConfirmationDialog = ({
    open,
    onClose,
    title,
    message,
    primaryAction,
    primaryLabel,
    secondaryAction,
    secondaryLabel = 'CANCEL',
    primaryVariant = 'contained',
    secondaryVariant = 'outlined'
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 1,
                    p: 3
                }
            }}
        >
            <DialogTitle sx={{ p: 0, pb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ p: 0, pb: 3 }}>
                <Typography variant="body1" color="text.secondary">
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 0, gap: 1 }}>
                <StyledButton
                    variant={primaryVariant}
                    onClick={primaryAction}
                >
                    {primaryLabel}
                </StyledButton>
                {secondaryAction && (
                    <StyledButton
                        variant={secondaryVariant}
                        onClick={secondaryAction}
                    >
                        {secondaryLabel}
                    </StyledButton>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;

